import { createAsyncThunk } from '@reduxjs/toolkit';

import { getFarmTypes } from '../../../service/graphql/account/getFarmTypes';
import { AsyncThunkConfig } from '../../store';

export const getFarmTypesThunk = createAsyncThunk<string[], void, AsyncThunkConfig>(
  'userAccount/getFarmTypes',
  async (_, { getState }) => {
    const { launchDarkly } = getState();
    return getFarmTypes(launchDarkly.data);
  },
);
